import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';

export default function AddHistoryDialog({ dialogOpen, setDialogOpen, updateID, setUpdateID }) {
  const [historyData, setHistoryData] = useState([]);
  const [Description, setDescription] = useState('');
  const [DoctorID, setDoctorID] = useState('');
  const [doctors, setDoctors] = useState([]);
  const [file, setFile] = useState(null);

  // Fetch doctors when the component mounts
  useEffect(() => {
    fetchDoctors();
  }, []);

  const fetchDoctors = () => {
    axios
      .get('https://serverfourpaws.ccsoftwares.com/Doctor/getDoctorDetails')
      .then((res) => {
        setDoctors(res.data);
      })
      .catch((err) => {
        console.error('Error fetching doctors:', err);
      });
  };

  const handleClose = () => {
    setDialogOpen(false);
    clearData();
    setUpdateID(0);
  };

  const clearData = () => {
    setHistoryData([]);
    setDescription('');
    setDoctorID('');
    setFile(null);
  };

  const handleSubmit = () => {
    const data = new FormData();
    data.append('updateID', updateID);
    data.append('DoctorID', DoctorID);
    data.append('Description', Description);
    if (file) {
      data.append('file', file);
    }

    axios
      .post(`https://serverfourpaws.ccsoftwares.com/Pet/AddNewHistory/`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        clearData();
        handleClose();
      })
      .catch((err) => {
        console.error('Error adding history:', err);
      });
  };

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={dialogOpen}
      fullWidth={true}
      maxWidth="lg"
    >
      <DialogTitle sx={{ m: 0, p: 3 }} id="customized-dialog-title">
        <strong>Add Pet History Data</strong>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon sx={{ color: 'black' }} />
      </IconButton>
      <DialogContent dividers>
        <Container maxWidth={false}>
          <Box mt={0}>
            <Grid container spacing={2}>
              {/* Doctor Selection Dropdown */}
              <Grid item md={6} xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="doctor-label">Doctor</InputLabel>
                  <Select
                    labelId="doctor-label"
                    id="doctor"
                    value={DoctorID}
                    label="Doctor"
                    onChange={(e) => setDoctorID(e.target.value)}
                  >
                    {doctors.map((doctor) => (
                      <MenuItem key={doctor.DoctorID} value={doctor.Name}>
                        {doctor.Name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* File Upload Button */}
              <Grid item md={6} xs={12}>
                <Button variant="contained" component="label">
                  Upload File
                  <input
                    type="file"
                    hidden
                    onChange={(e) => setFile(e.target.files[0])}
                    accept="image/*,.pdf"
                  />
                </Button>
                {file && (
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    Selected File: {file.name}
                  </Typography>
                )}
              </Grid>

              {/* Description Field */}
              <Grid item md={12} xs={12}>
                <TextField
                  fullWidth
                  label="Description"
                  name="Description"
                  value={Description}
                  id="Description"
                  onChange={(e) => setDescription(e.target.value)}
                  variant="outlined"
                  size="small"
                  type="text"
                  multiline
                  rows={4}
                />
              </Grid>

              {/* Submit Button */}
              <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button variant="contained" onClick={handleSubmit} sx={{ width: '30%' }}>
                  Add History
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </DialogContent>
    </Dialog>
  );
}
